module.exports = __webpack_public_path__ + "img/webapp-share.d3f5b7dc.svg";